export function saveItem(key, value) {
    try {
        localStorage[key] = value;
    }
    catch (e) {
    }
}
